import Vue from 'vue';
import VueRouter from 'vue-router';
import { Notification } from 'element-ui';
import i18n from '../utils/i18n';
import store from '../store';
import { getUserProfile } from '../utils/common';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    component: () => import('@/layout/AuthLayout'),
    name: 'PortalAuthLayout',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/Login'),
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/auth/ForgotPassword'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/auth/Register'),
      },
      {
        path: 'iam/register',
        name: 'IamRegister',
        component: () => import('@/views/auth/Register'),
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: () => import('@/views/auth/ResetPassword'),
      },
      {
        path: 'verify-email',
        name: 'VerifyEmail',
        component: () => import('@/views/auth/VerifyEmail'),
      },
      {
        path: 'confirm-email',
        name: 'ConfirmEmail',
        component: () => import('@/views/auth/ConfirmEmail'),
      },
      {
        path: 'unlock',
        name: 'UnlockAccount',
        component: () => import('@/views/auth/UnlockAccount'),
      },
      {
        path: 'otp',
        name: 'OtpVerify',
        component: () => import('@/views/auth/Otp'),
      },
      {
        path: 'trial-pending',
        name: 'TrialPending',
        component: () => import('@/views/auth/TrialPending'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/layout/CloudLayout'),
    name: 'CloudLayout',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/cs/index'),
        meta: { title: i18n.t('pageTitle.dashboard'), docsPath: 'docs/getting-started' },
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import('@/views/cs/account/AccountProfile'),
        meta: { title: i18n.t('page.account'), docsPath: 'docs/account' },
      },
      //server
      {
        path: 'server',
        name: 'Server',
        component: () => import('@/views/cs/server/Server'),
        meta: { title: i18n.t('pageTitle.server'), docsPath: 'docs/cloud-server' },
      },
      {
        path: 'server/create',
        name: 'CreateServer',
        component: () => import('@/views/cs/server/Create'),
        meta: { title: i18n.t('page.createServer'), docsPath: 'docs/cloud-server', permission: 'iam_manage_resources' },
      },
      {
        path: 'server/:id/detail',
        name: 'DetailServer',
        component: () => import('@/views/cs/server/Detail'),
        meta: { title: i18n.t('page.detailServer'), docsPath: 'docs/cloud-server' },
      },
      {
        path: 'server-group',
        name: 'ServerGroup',
        component: () => import('@/views/cs/server-group/ServerGroups'),
        meta: { title: i18n.t('serverGroup.title'), docsPath: 'docs/cloud-server' },
      },
      {
        path: 'server-group/:id/detail',
        name: 'DetailServerGroup',
        component: () => import('@/views/cs/server-group/Detail'),
        meta: { title: i18n.t('page.detailServerGroup'), docsPath: 'docs/cloud-server' },
      },
      //Network
      {
        path: 'networks',
        name: 'Networks',
        component: () => import('@/views/cs/network/networks/Networks'),
        meta: { title: i18n.t('pageTitle.network'), docsPath: 'docs/network' },
      },
      {
        path: 'networks/create',
        name: 'Create Networks',
        component: () => import('@/views/cs/network/networks/Create'),
        meta: { title: i18n.t('form.create', { item: 'Network' }), docsPath: 'docs/network' },
      },
      {
        path: 'networks/:id/detail',
        name: 'Detail network',
        component: () => import('@/views/cs/network/networks/Detail'),
        meta: { title: i18n.t('page.detailNetwork'), docsPath: 'docs/network' },
      },
      {
        path: 'networks/port/:id/detail',
        name: 'Detail port',
        component: () => import('@/views/cs/network/port/Detail'),
        meta: { title: i18n.t('page.detailPort'), docsPath: 'docs/network' },
      },
      {
        path: 'floating-ip',
        name: 'Floating IP',
        component: () => import('@/views/cs/network/floating-ip/FloatingIp'),
        meta: { title: i18n.t('pageTitle.floatingIp'), docsPath: 'docs/network' },
      },
      {
        path: 'floating-ip/create',
        name: 'Allocate Floating Ip',
        component: () => import('@/views/cs/network/floating-ip/Create'),
        meta: { title: i18n.t('pageTitle.allocateFloatingIp'), docsPath: 'docs/network', permission: 'iam_manage_resources' },
      },
      {
        path: 'port/create',
        name: 'Create Port',
        component: () => import('@/views/cs/network/port/Create'),
        meta: { title: i18n.t('form.create', { item: 'Port' }), docsPath: 'docs/network', permission: 'iam_manage_resources' },
      },
      //Router
      {
        path: 'routers',
        name: 'Routers',
        component: () => import('@/views/cs/network/router/Router'),
        meta: { title: i18n.t('pageTitle.router'), docsPath: 'docs/network' },
      },
      {
        path: 'routers/create',
        name: 'Create Routers',
        component: () => import('@/views/cs/network/router/Create'),
        meta: { title: i18n.t('form.create', { item: 'Router' }), docsPath: 'docs/network', permission: 'iam_manage_resources' },
      },
      {
        path: 'routers/:id/detail',
        name: 'Detail Routers',
        component: () => import('@/views/cs/network/router/Detail'),
        meta: { title: i18n.t('page.detailRouter'), docsPath: 'docs/network' },
      },
      //security-group
      {
        path: 'security-group',
        name: 'Security Group',
        component: () => import('@/views/cs/network/security-group/SecurityGroup'),
        meta: { title: i18n.t('pageTitle.securityGroup'), docsPath: 'docs/network' },
      },
      {
        path: 'security-group/create',
        name: 'Create Security Group',
        component: () => import('@/views/cs/network/security-group/Create'),
        meta: { title: i18n.t('form.create', { item: 'Security Group' }), docsPath: 'docs/network' },
      },
      {
        path: 'security-group/:id/detail',
        name: 'Security Group Rules',
        component: () => import('@/views/cs/network/security-group/Detail'),
        meta: { title: i18n.t('page.detail', { item: 'Security Group' }), docsPath: 'docs/network' },
      },
      // subnet
      {
        path: 'subnet/create',
        name: 'Subnet',
        component: () => import('@/views/cs/network/subnet/Create'),
        meta: { title: i18n.t('form.create', { item: 'Subnet' }), docsPath: 'docs/network' },
      },
      //volume
      {
        path: 'volume',
        name: 'Volume',
        component: () => import('@/views/cs/volume/Volume'),
        meta: { title: i18n.t('volume.title'), docsPath: 'docs/disk' },
      },
      {
        path: 'volume/create',
        name: 'Create Volume',
        component: () => import('@/views/cs/volume/Create'),
        meta: { title: i18n.t('form.create', { item: i18n.t('volume.title') }), docsPath: 'docs/disk', permission: 'iam_manage_resources' },
      },
      //schedule snapshot
      {
        path: 'schedule-snapshot',
        name: 'Schedule Snapshot',
        component: () => import('@/views/cs/schedule-snapshot/ScheduleSnapshot'),
        meta: { title: i18n.t('scheduleSnapshot.title'), docsPath: 'docs/disk' },
      },
      {
        path: 'schedule-snapshot/create',
        name: 'ScheduleShotCreate',
        component: () => import('@/views/cs/schedule-snapshot/Create'),
        meta: { title: i18n.t('form.create', { item: i18n.t('scheduleSnapshot.title') }), docsPath: 'docs/disk' },
      },
      //ssh
      {
        path: 'ssh',
        name: 'Ssh key',
        component: () => import('@/views/cs/ssh/Ssh'),
        meta: { title: i18n.t('pageTitle.sshKey'), docsPath: 'docs/sshkey' },
      },
      {
        path: 'ssh/create',
        name: 'Create Ssh Key',
        component: () => import('@/views/cs/ssh/Create'),
        meta: { title: i18n.t('form.create', { item: 'SSH Key' }), docsPath: 'docs/sshkey' },
      },
      {
        path: 'ticket',
        name: 'Ticket',
        component: () => import('@/views/cs/ticket/Ticket'),
        meta: { title: i18n.t('pageTitle.ticket'), docsPath: 'docs/ticket' },
      },
      {
        path: 'order/:id/detail',
        name: 'Order',
        component: () => import('@/views/order/Detail'),
        meta: { title: '' },
      },
      {
        path: 'billing/charge',
        name: 'Charge',
        component: () => import('@/views/billing/Charge'),
        meta: { title: '', docsPath: 'docs/billing' },
      },
      {
        path: 'billing/result',
        name: 'Result',
        component: () => import('@/views/billing/ChargeResult'),
        meta: { title: '', docsPath: 'docs/billing' },
      },
      {
        path: 'deposit/:id/:name/:plan',
        name: 'Deposit',
        component: () => import('@/views/billing/Deposit'),
        meta: { title: '', docsPath: 'docs/billing' },
      },
      {
        path: 'ticket/:id',
        name: 'TicketDetail',
        component: () => import('@/views/cs/ticket/show'),
        meta: { docsPath: 'docs/ticket' },
      },
      {
        path: 'billing',
        name: 'Billing',
        component: () => import('@/views/cs/billing/Billing'),
        meta: { title: i18n.t('pageTitle.billing'), docsPath: 'docs/billing' },
      },
      {
        path: 'iam',
        name: 'Iam',
        component: () => import('@/views/iam/Iam'),
        meta: { title: i18n.t('pageTitle.iam'), docsPath: 'docs/iam' },
      },
      {
        path: 'Resource',
        name: 'Resource',
        component: () => import('@/views/iam/Resource'),
        meta: { title: i18n.t('common.resource'), docsPath: 'docs/iam' },
      },
      {
        path: 'alert',
        name: 'Alert',
        component: () => import('@/views/cs/alert/Alert'),
        meta: { title: i18n.t('common.alert') },
      },
      {
        path: 'renew',
        name: 'Renew',
        component: () => import('@/views/billing/Subscription'),
        meta: { title: i18n.t('pageTitle.subscription'), docsPath: 'docs/subscription-plan' },
      },
      {
        path: 'activity-logs',
        name: 'ActivityLog',
        component: () => import('@/views/activity-log/ActivityLog'),
        meta: { title: i18n.t('pageTitle.activityLog'), docsPath: 'docs/action-logs' },
      },
      // Load balancer
      {
        path: 'load-balancer',
        name: 'LoadBalancer',
        component: () => import('@/views/lb/index'),
        meta: { title: i18n.t('pageTitle.loadBalancer') },
      },
      {
        path: 'load-balancer/create',
        name: 'CreateLoadBalancer',
        component: () => import('@/views/lb/create'),
        meta: { title: i18n.t('form.create', { item: 'Load Balancer' }) },
      },
      {
        path: 'load-balancer/certificates',
        name: 'LoadBalancerCertificates',
        component: () => import('@/views/lb/certs'),
        meta: { title: i18n.t('pageTitle.lbCertificates') },
      },
      // S3
      {
        path: 'simple-storage',
        name: 'SimpleStorage',
        component: () => import('@/views/simple-storage/SimpleStorage'),
        meta: { title: i18n.t('pageTitle.simpleStorage'), docsPath: 'docs/simple-storage' },
      },
      {
        path: 'simple-storage/create',
        name: 'CreateSimpleStorage',
        component: () => import('@/views/simple-storage/Create'),
        meta: { title: i18n.t('form.create', { item: 'Bucket' }), docsPath: 'docs/simple-storage', permission: 'iam_manage_resources' },
      },
      {
        path: 'simple-storage/access-key',
        name: 'CreateSimpleStorageKey',
        component: () => import('@/views/simple-storage/AccessKey'),
        meta: { title: i18n.t('pageTitle.accessKey'), docsPath: 'docs/simple-storage' },
      },
      {
        path: 'simple-storage/:name/detail',
        name: 'DetailS3',
        component: () => import('@/views/simple-storage/Detail'),
        meta: { title: i18n.t('page.detail', { item: 'Bucket' }), docsPath: 'docs/simple-storage' },
      },
      {
        path: 'simple-storage/sub-user',
        name: 'SubUser',
        component: () => import('@/views/simple-storage/SubUser'),
        meta: { title: i18n.t('pageTitle.subUser'), docsPath: 'docs/simple-storage' },
      },
      //vpn
      {
        path: 'vpn',
        name: 'VPN',
        component: () => import('@/views/vpn/Vpn'),
        meta: { title: i18n.t('pageTitle.vpnGateway') },
      },
      {
        path: 'vpn/create',
        name: 'CreateVPN',
        component: () => import('@/views/vpn/Create'),
        meta: { title: i18n.t('form.create', { item: 'VPN Gateway' }), permission: 'iam_manage_resources' },
      },
      {
        path: 'vpn/:id/detail',
        name: 'Gateway Detail',
        component: () => import('@/views/vpn/Detail'),
        meta: { title: i18n.t('page.detail', { item: 'VPN Gateway' }) },
      },
    ],
  },
  {
    path: '/load-balancer',
    component: () => import('@/layout/LoadBalancerLayout'),
    name: 'LoadBalancerLayout',
    children: [
      {
        path: ':id/listener',
        name: 'LoadBalancerListener',
        component: () => import('@/views/lb/listener/index'),
        meta: { title: i18n.t('pageTitle.listener') },
      },
      {
        path: ':id/monitoring',
        name: 'LoadBalancerMonitoring',
        component: () => import('@/views/lb/monitoring/index'),
        meta: { title: i18n.t('pageTitle.monitoring') },
      },
      {
        path: ':id/usages',
        name: 'LoadBalancerUsages',
        component: () => import('@/views/lb/usages/index'),
        meta: { title: i18n.t('pageTitle.usage') },
      },
      {
        path: ':id/group-server',
        name: 'LoadBalancerGroupServer',
        component: () => import('@/views/lb/group-server/index'),
        meta: { title: i18n.t('pageTitle.pool') },
      },
      {
        path: ':id/flavors',
        name: 'LoadBalancerFlavors',
        component: () => import('@/views/lb/flavors/index'),
        meta: { title: i18n.t('pageTitle.lbFlavor') },
      },
      {
        path: ':id/delete',
        name: 'LoadBalancerDelete',
        component: () => import('@/views/lb/delete/index'),
        meta: { title: i18n.t('constants.orderAction.deleteLoadBalancer') },
      },
    ]
  },
  {
    path: '/',
    component: () => import('@/layout/PublicLayout'),
    name: 'PublicLayout',
    children: [
      {
        path: 'billing/invoice-details',
        name: 'InvoiceDetails',
        component: () => import('@/views/billing/InvoiceDetails'),
        meta: { title: '' },
      },
    ]
  },
  {
    path: '/',
    component: () => import('@/layout/BillLayout'),
    name: 'BillLayout',
    children: [
      {
        path: 'billing/bills/:id',
        name: 'Bill',
        component: () => import('@/views/public/Bill'),
      },
      {
        path: 'billing/receipts/:id',
        name: 'Receipt',
        component: () => import('@/views/public/Receipt'),
      },
    ]
  },
  {
    path: "/sso/authorize",
    name: "SsoAuthorize",
    component: () => import("@/views/auth/SsoAuthorize.vue"),
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

// How long the guard waits for the profile/permission fetch before giving up and
// evaluating with whatever it has (see below) instead of hanging navigation forever.
const PERMISSION_CHECK_TIMEOUT_MS = 15000;

// Mirrors the checkPermission() gates already used inside the corresponding Create
// views (e.g. Create.vue's footer submit button) at the navigation level, so that
// typing/bookmarking the URL directly can't reach a form the UI otherwise hides.
// This only enforces meta.permission that a view already declares for itself; it is
// not a general auth guard and doesn't change which permission is required for what.
router.beforeEach(async (to, from, next) => {
  const requiredPermission = to.meta && to.meta.permission;
  if (!requiredPermission) return next();

  // getUserProfile() is what actually populates userProfile.iam_info.permissions, and it
  // dedupes against any in-flight call (see utils/common.js) so this doesn't fire a second
  // request when App.vue's beforeMount already triggered one for the very first navigation.
  // Calling it explicitly here — rather than guessing how many ticks App.vue's mount needs
  // to run first — means this guard doesn't depend on timing between two separate files.
  // A bounded timeout still caps it: getUserProfile() always resolves `isLoadingPage` back
  // to false on its own (success or error), but if that somehow doesn't happen we still want
  // next() to be called rather than leaving the navigation stuck with no feedback.
  if (!store.getters.userProfile || !store.getters.userProfile.iam_info) {
    await Promise.race([
      getUserProfile(false),
      new Promise((resolve) => setTimeout(resolve, PERMISSION_CHECK_TIMEOUT_MS)),
    ]);
  }

  const accountPermissions = (store.getters.userProfile && store.getters.userProfile.iam_info && store.getters.userProfile.iam_info.permissions) || [];
  if (accountPermissions.includes(requiredPermission)) return next();

  Notification({
    title: i18n.t('notification.error.title'),
    message: i18n.t('notification.error.permissionDenied'),
    type: 'error',
    customClass: 'error',
  });
  next('/dashboard');
});

export default router;
